import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, finalize } from 'rxjs';
import { ApiBridgeService } from 'src/app/api-bridge.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  isLoading$: Observable<boolean> | undefined;
  isLoadingSubject = new BehaviorSubject<boolean>(false);

  constructor(
    private apiBridgeService: ApiBridgeService,
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  getDashboardData(currency: string): Observable<any> {
    this.isLoadingSubject.next(true);

    const endpoint = `app/auth/dashboard?currency=${currency}`;

    return this.apiBridgeService
      .get(endpoint)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getBalance(): Observable<any> {
    this.isLoadingSubject.next(true);

    const endpoint = `app/auth/account`;

    return this.apiBridgeService
      .get(endpoint)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }
}
